// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createFromProduct } from "@insite/client-framework/Common/ProductInfo";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { chain, LoadInventory } from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";

export const LoadPricing: any = async (props: any) => {
    const product = props.product;
    if (!product || !props.parameter.loadPricing) {
        return;
    }
    props.productInfo = createFromProduct(product);
    let pricingLoaded = false;
    const relatedPricing = props.getState().commonActions["relatedProductPricing"];
    const pricingData = relatedPricing ? { ...relatedPricing } : {};

    // make sure we dont have the data for pricing already fetched before
    if (!pricingData?.hasOwnProperty(product.id)) {
        props.dispatch(
            loadRealTimePricing({
                productPriceParameters: [props.productInfo],
                onComplete(realTimePricingProps) {
                    if (realTimePricingProps.apiResult && realTimePricingProps.apiResult.realTimePricingResults) {
                        const pricing = realTimePricingProps.apiResult.realTimePricingResults.find(
                            o => o.productId === product.id,
                        );
                        if (pricingData?.hasOwnProperty(product.id)) {
                            pricingData[product.id] = pricing;
                        } else {
                            pricingData[product.id] = "";
                            pricingData[product.id] = pricing;
                        }
                        props.dispatch({
                            type: "commonActionSetter/SetAction",
                            payload: {
                                name: "relatedProductPricing",
                                value: { ...pricingData },
                            },
                        } as any);
                        pricingLoaded = true;
                    } else if (realTimePricingProps.error) {
                        pricingLoaded = true;
                    }
                },
            }),
        );
    }
    pricingLoaded = true;
    await waitFor(() => pricingLoaded);
};

addToChainBefore(chain, LoadInventory, LoadPricing);
